import {Component, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {DialogModule} from "../../../../../common/dialog/dialog.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {FormModule} from "../../../../../form/form.module";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RichTextEditorModule} from "../../../../../../components/common/rich-text-editor/rich-text-editor.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {BaseView} from "../../../../../core/view/base.view";
import {IDialogComponent} from "../../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../../common/dialog/dialogWithInput";
import {RichTextEditorComponent} from "../../../../../../components/common/rich-text-editor/rich-text-editor.component";
import {SpellCheckTextService} from "../../service/spellCheckText.service";
import {
  AudioTranscriptionConfig,
  AudioTranscriptionHandler
} from "../../../../../common/audio/transcription/api/component/audio-transcription-v2/audio-transcription-v2.component";

export interface SpellCheckDialogInput {
  text?: string;
  audioTranscriptionHandler?: AudioTranscriptionHandler<any>;
}

export interface SpellCheckDialogResult {
 correctedText: string;
}

@Component({
  templateUrl: './spell-check-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormFieldModule,
    FormModule,
    ReactiveFormsModule,
    RichTextEditorModule,
    ButtonModule,
  ],
  providers: [
    SpellCheckTextService
  ]
})
export class SpellCheckDialogComponent extends BaseView implements
    IDialogComponent<SpellCheckDialogInput, SpellCheckDialogResult> {

  dialog: DialogWithInput<SpellCheckDialogInput, SpellCheckDialogResult>;

  @ViewChild('editor') editor: RichTextEditorComponent;

  audioTranscriptionConfig: AudioTranscriptionConfig;
  formGroup: FormGroup;
  loading = false;

  constructor(private formBuilder: FormBuilder,
              private service: SpellCheckTextService) {
    super();
    this.formGroup = this.formBuilder.group({
      text: new FormControl(undefined, Validators.required)
    });
  }

  ngOnInit() {
    if (this.dialog.input.text) {
      this.formGroup.patchValue({
        text: this.dialog.input.text
      });
    }

    this.audioTranscriptionConfig = {
      context: 'none',
      audioContentValue: 'AUDIO_CONTENT_TEXT_SPELL_CHECK',
      startAutomatically: false,
      enableConversationOption: false,
      handler: this.dialog.input.audioTranscriptionHandler,
      showPreview: true,
    }
  }

  spellCheck() {
    this.loading = true;
    this.editor.stopTranscription();
    this.service.execute({
      text: this.formGroup.get('text').value,
    })
        .toPromise()
        .then(result => {
          this.dialog.close({
            correctedText: result.text
          });
        })
        .catch(e => {
          this.toastControl.presentError(e);
        })
        .finally(() => {
          this.loading = false;
        });
  }
}
